import { PDFDocument } from "pdf-lib";
import { cropRectToPdf, FULL_CROP } from "./pdf-crop-core.js";

export async function cropPdf(sourceBytes, crops) {
  const output = await PDFDocument.load(sourceBytes.slice ? sourceBytes.slice() : sourceBytes, { updateMetadata: false });
  output.getPages().forEach((page, index) => {
    const crop = crops?.get?.(index + 1) || crops?.[index + 1] || FULL_CROP;
    const box = cropRectToPdf(crop, page.getCropBox(), page.getRotation().angle);
    page.setCropBox(box.x, box.y, box.width, box.height);
  });
  output.setCreator("smallpdf.app");
  output.setProducer("smallpdf.app Crop PDF");
  return output.save({ useObjectStreams: true });
}
